<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>

useHead({
  titleTemplate: (title) => {
    if (!title) return 'LEÓN Servicio Automotriz'
    return title
  },
})

useGlobalSeo();
useModoSistema();

</script>
